import React from 'react';
import { NexusButton } from './NexusButton';
import { NexusModal } from './NexusModal';

export function ConfirmDialog({ open, title, message, confirmLabel = 'Confirm', cancelLabel = 'Back', onConfirm, onCancel }) {
  return (
    <NexusModal open={open} onClose={onCancel} maxWidth={560}>
      <h2 style={{ fontFamily: 'Gilroy-Bold, Gilroy-ExtraBold, Inter, sans-serif', fontSize: 22, fontWeight: 800, marginBottom: 8 }}>{title}</h2>
      {message ? <p style={{ color: 'var(--text2)', fontSize: 13, margin: '0 0 14px' }}>{message}</p> : null}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
        <NexusButton variant="secondary" type="button" onClick={onCancel}>{cancelLabel}</NexusButton>
        <NexusButton type="button" onClick={onConfirm}>{confirmLabel}</NexusButton>
      </div>
    </NexusModal>
  );
}
